import axios from 'axios'
import { baseApiUrl } from '../config/config'

export const getTranTypes = async (params) => {
  try {
    const res = await axios.get(`${baseApiUrl}/transport-types`, { params })
    // console.log(res.data)
    return res.data
  } catch (err) {
    throw new Error(err.name)
    // return null
  }
}

export const getDayTypes = async (params) => {
  try {
    const res = await axios.get(`${baseApiUrl}/days-types`, { params })
    // console.log(res.data)
    return res.data
  } catch (err) {
    throw new Error(err.name)
    // return null
  }
}

export const getTranRoutes = async (params) => {
  // console.log(params)
  try {
    const res = await axios.get(`${baseApiUrl}/routes`, { params })
    // console.log(res.data)
    return res.data
  } catch (err) {
    throw new Error(err.name)
    // return null
  }
}

export const getRoutesStops = async (params) => {
  // console.log(params)
  try {
    const res = await axios.get(`${baseApiUrl}/routes-stops`, { params })
    // console.log(res.data)
    return res.data
  } catch (err) {
    throw new Error(err.name)
    // return null
  }
}

export const getLocales = async (params) => {
  try {
    const res = await axios.get(`${baseApiUrl}/locales`, { params })
    // console.log(res.data)
    return res.data
  } catch (err) {
    throw new Error(err.name)
    // return null
  }
}
